import { PageLayout } from '@ferreri/prever-component-lib/nextjs';
import { ValidSessionRoute } from '@ferreri/minato-auth-react';
import CompaniesNew from '@modules/companies/CompaniesNew';
import { PAGE_TITLE } from '@utils/pageTitle';

export default function CompaniesNewPage() {
  return (
    <ValidSessionRoute
      loadingComponent={
        <PageLayout title={PAGE_TITLE.companies.new}>
          <CompaniesNew />
        </PageLayout>
      }
    >
      <PageLayout title={PAGE_TITLE.companies.new}>
        <CompaniesNew />
      </PageLayout>
    </ValidSessionRoute>
  );
}
